import apiClient from './api';

// Servicio para manejar las operaciones relacionadas con el onboarding.
// Nota: el backend nuevo identifica al usuario por el token (no por
// user_id en la URL), así que ya no hace falta mandarlo — se deja el
// parámetro en la firma de las funciones para no romper a quien las
// llama, pero no se usa.
const onboardingService = {
  saveOnboardingData: async (data, _userId) => {
    try {
      const response = await apiClient.post('/onboarding/save', data);
      return response.data;
    } catch (error) {
      console.error('Error al guardar datos de onboarding:', error);
      throw error;
    }
  },

  updateOnboardingState: async (stateData, _userId) => {
    try {
      const params = {};
      if (stateData.completed !== undefined) params.completed = stateData.completed;
      if (stateData.currentStep) params.current_step = stateData.currentStep;
      if (stateData.progress) {
        if (stateData.progress.accounts !== undefined) params.accounts_completed = stateData.progress.accounts;
        if (stateData.progress.debts !== undefined) params.debts_completed = stateData.progress.debts;
        if (stateData.progress.incomes !== undefined) params.incomes_completed = stateData.progress.incomes;
        if (stateData.progress.expenses !== undefined) params.expenses_completed = stateData.progress.expenses;
        if (stateData.progress.summary !== undefined) params.summary_completed = stateData.progress.summary;
      }

      const response = await apiClient.post('/onboarding/update-state', null, { params });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar estado de onboarding:', error);
      throw error;
    }
  },

  getOnboardingData: async (_userId) => {
    try {
      const response = await apiClient.get('/onboarding/data');
      return response.data;
    } catch (error) {
      console.error('Error al obtener datos de onboarding:', error);
      throw error;
    }
  },

  hasFinancialRecords: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}/has-financial-records`);
      return response.data.hasRecords;
    } catch (error) {
      console.error('Error al verificar si el usuario tiene registros financieros:', error);
      return false;
    }
  },
};

export default onboardingService;
